export default "/_next/static/chunks/fonts/Play Regular-e0424c5771f87080b05ef38186617800.ttf";